<div id="container" class="fadeIn def_back gallery-books container-md">
  <div id="container-border"></div>
  <div id="container-bottom"></div>

  <header class="text-center mb-5 mt-3">
    <h1 class="titles">Il Grimorio dei Mondi</h1>
    <div class="section-divider main-divider">
      <i class="fas fa-book"></i>
    </div>
  </header>

  <section class="row mb-4 align-items-start">
    <div class="col-12 col-lg-4 mb-5">
      <div class="book-cover-wrapper text-center">
        <a href="https://www.amazon.it/dp/B0GMLS42CS" target="_blank">
          <img src="https://tools.sandbay.it/public/books/images/IlGrimorioDeiMondi.jpg" alt="Copertina Libro" class="img-fluid rounded">
        </a>
      </div>
    </div>
    <div class="col-12 col-lg-8 text-center text-lg-start">
      <div class="book-description">
        <p class="lead italic-quote mb-3 text-center text-lg-start">
          "Sei orizzonti. Sei destini. Un unico viaggio oltre l'immaginazione."
        </p>
        <p class="mb-3 text-center text-lg-start">
          Tra queste pagine, il tempo non scorre in linea retta,<br>
          ma si piega sotto il peso di segreti millenari e festival di follia.<br>
        </p>
        <p class="mb-3 text-center text-lg-start">
          Dalle ombre inquietanti di una piramide dimenticata ai coriandoli di un carnevale che maschera l'orrore;
          dai villaggi scavati nel cuore di alberi secolari ai mari infiniti solcati da navi pirata.<br>
          Il Grimorio dei Mondi ti offre l'accesso a sei frammenti di esistenza unici.
        </p>
        <p class="mb-3 text-center text-lg-start">
          Preparati a incontrare nani sognatori, mummie dal ghigno gelido e antichi poteri pronti a risvegliarsi.<br>
          Non importa quale sentiero sceglierai di percorrere per primo:
          ogni capitolo è una sfida, ogni incontro è un enigma, ogni scelta è definitiva.
        </p>
        <p class="mb-3 text-center text-lg-start">Apri il grimorio. Esplora i mondi. Scrivi la leggenda.</p>
      </div>
    </div>
  </section>

  <div *ngIf="showAmazonCTA" class="amazon-cta-container animate__animated animate__fadeIn">
    <a href="https://www.amazon.it/dp/B0GMLS42CS" target="_blank" class="btn-portal vortex-background">
      <i class="fab fa-amazon"></i>
      <span>Ottieni il tuo Grimorio</span>
    </a>
    <span class="cta-subtitle">Disponibile ora in formato fisico su Amazon</span>
  </div>

  <section class="adventures-grid">
    <div class="digital-contents-header">
      <h2>Frammenti di Mondi</h2>
      <div class="section-divider">
        <i class="fas fa-scroll"></i>
      </div>
      <p class="section-description">
        Espandi la tua esperienza di gioco. In questa sezione puoi consultare le mappe tattiche ad alta risoluzione
        e accedere agli strumenti interattivi progettati per rendere le tue sessioni indimenticabili.
      </p>
    </div>

    <div class="row g-4">
      <div class="col-12 col-lg-6 col-xl-4" *ngFor="let adv of adventures; let i = index">
        <div class="adventure-card shadow-sm mx-2 mx-md-0">
         <div class="adventure-number">Avventura {{ i + 1 }} - {{ adv.subtitle}}</div>
          <h3 class="h5 card-title">{{ adv.title }}</h3>
          <img [src]="adv.coverThumb" class="adventure-thumb" alt="Preview">
          <p class="card-text small text-muted">{{ adv.description }}</p>

          <div class="adventure-footer">
            <div class="spoiler-overlay" *ngIf="!unlockedAdventures[i]" (click)="unlockAdventure(i)">
              <i class="fas fa-eye-slash"></i>
              <span>Mostra Mappe e Contenuti</span>
            </div>

            <div *ngIf="unlockedAdventures[i]" class="animate__animated animate__fadeIn">

              <div class="map-thumbnails mt-3">
                <div class="map-thumb" *ngFor="let map of adv.maps" (click)="openLightbox(map)">
                  <img [src]="map.thumb" [alt]="map.name">
                  <div class="thumb-overlay">
                    <i class="fas fa-search-plus"></i>
                  </div>
                </div>
              </div>

              <div *ngIf="i === 5" class="special-tool-link">
                <a href="https://tools.sandbay.it/public/tools/assets/gothic-organ/index-dd.html"
                   target="_blank" class="btn-gothic-tool">
                  <i class="fas fa-music"></i>
                  <span>Vai all'app del Gothic Organ</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="custom-lightbox" *ngIf="selectedMap" (click)="closeLightbox()">

    <div class="map-title-overlay">
      {{ selectedMap.name }}
    </div>

    <div class="lightbox-content">
      <img [src]="selectedMap.full"
           [style.transform]="'rotate(' + currentRotation + 'deg)'"
           [ngClass]="(currentRotation / 90) % 2 !== 0 ? 'is-rotated' : 'is-normal'"
           (click)="$event.stopPropagation()">
    </div>

    <div class="controls-sidebar" (click)="$event.stopPropagation()">
      <button class="btn-action-round btn-fullscreen" (click)="toggleFullscreen($event)" title="Fullscreen">
        <i class="fas fa-expand"></i>
        <span>Full</span>
      </button>

      <button class="btn-action-round" (click)="rotateImage($event)" title="Ruota">
        <i class="fas fa-redo"></i>
        <span>Ruota</span>
      </button>

      <!--
      <a [href]="selectedMap.full"
         [download]="selectedMap.name"
         class="btn-action-round"
         title="Download">
        <i class="fas fa-download"></i>
        <span>Salva</span>
      </a>
      -->
      <button class="btn-action-round" (click)="downloadImage($event)" title="Download">
        <i class="fas fa-download"></i>
        <span>Salva</span>
      </button>

      <button class="btn-action-round btn-close" (click)="closeLightbox()" title="Chiudi">
        <i class="fas fa-times"></i>
        <span>Esci</span>
      </button>
    </div>
  </div>
</div>
